import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { SIZE } from '../../../constants/size'
import { FormModal } from '../../Form'
import { MODAL_HEADER_VARIANT, useResizeModal } from '../../Modal'
import { useWysiwygEditorFullScreenHeight } from '../../WysiwygEditor'

import { REQUEST_EDIT_DESCRIPTION_MODAL_QA_NAME } from './RequestEditDescriptionModal.constants'
import {
  getRequestEditDescriptionModalPayload,
  getRequestEditDescriptionModalValidationSchema,
} from './RequestEditDescriptionModal.utils'
import { RequestEditDescriptionModalFields } from './RequestEditDescriptionModalFields'

function RequestEditDescriptionModal({
  initialValues,
  onSubmit,
  ...restProps
}) {
  const { fullScreen, handleResizeModal } = useResizeModal()

  const { contentRef, contentWrapperRef, handleEditorInit } =
    useWysiwygEditorFullScreenHeight({
      isFullScreen: fullScreen,
    })

  const formBodyProps = {
    contentProps: { contentRef, contentWrapperRef, isFullScreen: fullScreen },
    submitQaName: QA_NAME_SAVE_BTN,
    withNotifications: true,
  }

  const validationSchema = getRequestEditDescriptionModalValidationSchema({
    initialValues,
  })

  function handleSubmit({ values }) {
    onSubmit({
      payload: getRequestEditDescriptionModalPayload(values),
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={RequestEditDescriptionModalFields}
      containerProps={{
        boxSize: SIZE.LARGE,
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        isFullScreen: fullScreen,
        qaName: REQUEST_EDIT_DESCRIPTION_MODAL_QA_NAME,
        onResize: handleResizeModal,
      }}
      formBodyProps={formBodyProps}
      formFieldsProps={{ onInitEditor: handleEditorInit }}
      formTitle='Modal.RequestProfileEditDescriptionModalTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditDescriptionModal
